import { RequestService } from '../../services/RequestService';
import { GET_ORDER_STATUSES } from '../constants';

export const getOrderStatuses = payload => {
  return RequestService.get(GET_ORDER_STATUSES);
};
